import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import goClutchWhite from "../../images/goClutch_White.png";

const services = [
  { name: "Periodic Services", path: "/services/periodic", isAvailable: true },
  { name: "Denting & Painting", path: "/services/denting", isAvailable: true },
  { name: "Major Services", path: "/services/major", isAvailable: false },
  { name: "AC Services", path: "/services/ac", isAvailable: false },
  {
    name: "Car Detailing",
    path: "/services/car-detailing",
    isAvailable: false,
  },
  {
    name: "Tire Maintenance",
    path: "/services/tire-maintenance",
    isAvailable: false,
  },
  { name: "Car Spa", path: "/services/car-spa", isAvailable: false },
  {
    name: "Clutch & Suspension",
    path: "/services/clutch-suspension",
    isAvailable: false,
  },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [serviceMenuOpen, setServiceMenuOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setMobileOpen(open);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setServiceMenuOpen(!serviceMenuOpen);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setServiceMenuOpen(false);
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "black", boxShadow: 3 }}>
      <Toolbar>
        {/* Mobile Menu Button */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Logo */}
        <Link to="/" style={{ flexGrow: 1 }}>
          <img src={goClutchWhite} alt="GoClutch" style={{ height: 40 }} />
        </Link>

        {/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3 }}>
          <Button
            color="inherit"
            component={Link}
            to="/"
            sx={{ "&:hover": { color: "orangered" } }}
          >
            Home
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/about"
            sx={{ "&:hover": { color: "orangered" } }}
          >
            About
          </Button>
          <Button
            color="inherit"
            onClick={handleMenuOpen}
            endIcon={serviceMenuOpen ? <ExpandLess /> : <ExpandMore />}
            sx={{ "&:hover": { color: "orangered" } }}
          >
            Services
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/contact"
            sx={{ "&:hover": { color: "orangered" } }}
          >
            Contact Us
          </Button>
        </Box>

        {/* Services Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{ mt: 1 }}
        >
          {services.map((service, index) => (
            <MenuItem
              key={index}
              component={service.isAvailable ? Link : "div"}
              to={service.isAvailable ? service.path : "#"}
              onClick={service.isAvailable ? handleMenuClose : undefined}
              disabled={!service.isAvailable}
              sx={{
                "&:hover": {
                  color: service.isAvailable ? "orangered" : "gray",
                },
                opacity: service.isAvailable ? 1 : 0.6,
              }}
            >
              {service.name} {!service.isAvailable && "(Coming Soon)"}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 250, bgcolor: "black", height: "100vh", color: "white" }}
        >
          <IconButton
            onClick={toggleDrawer(false)}
            sx={{
              color: "white",
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
          <List>
            <ListItem
              button
              component={Link}
              to="/"
              onClick={toggleDrawer(false)}
              sx={{ "&:hover": { color: "orangered" } }}
            >
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/about"
              onClick={toggleDrawer(false)}
              sx={{ "&:hover": { color: "orangered" } }}
            >
              <ListItemText primary="About" />
            </ListItem>
            <ListItem
              button
              onClick={() => setServiceMenuOpen(!serviceMenuOpen)}
            >
              <ListItemText primary="Services" />
              {serviceMenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            {serviceMenuOpen && (
              <Box sx={{ pl: 3 }}>
                {services.map((service, index) => (
                  <ListItem
                    button
                    key={index}
                    component={service.isAvailable ? Link : "div"}
                    to={service.isAvailable ? service.path : "#"}
                    onClick={
                      service.isAvailable ? toggleDrawer(false) : undefined
                    }
                    disabled={!service.isAvailable}
                    sx={{
                      "&:hover": {
                        color: service.isAvailable ? "orangered" : "gray",
                      },
                      opacity: service.isAvailable ? 1 : 0.6,
                    }}
                  >
                    <ListItemText
                      primary={`${service.name} ${
                        !service.isAvailable ? "(Coming Soon)" : ""
                      }`}
                    />
                  </ListItem>
                ))}
              </Box>
            )}
            <ListItem
              button
              component={Link}
              to="/contact"
              onClick={toggleDrawer(false)}
              sx={{ "&:hover": { color: "orangered" } }}
            >
              <ListItemText primary="Contact Us" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
